<template>
  <DialogComponent
    id="form-modal"
    class="form-modal"
    :visible.sync="visible"
    :fullscreen="true"
    :show-close="false"
  >
    <div id="form-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">{{ modalTitle }}</h1>
        <div class="modal-actions col-2">
          <el-button
            v-if="activeStep == 2"
            type="primary"
            @click="editIVAConfig"
          >
            Save
          </el-button>

          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Close
          </el-button>
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          />
        </div>
      </div>
    </div>

    <el-form :disabled="processing">
      <audio
        id="voice-audio"
        type="audio/wav"
        style="display: none"
        src=""
      ></audio>

      <audio
        id="bg-noise-audio"
        type="audio/mp3"
        style="display: none"
        src="/bg-noise.mp3"
      ></audio>

      <el-steps :active="activeStep" finish-status="success">
        <el-step style="cursor: pointer" @click.native="goToStep(0)"></el-step>
        <el-step style="cursor: pointer" @click.native="goToStep(1)"></el-step>
        <el-step style="cursor: pointer" @click.native="goToStep(2)"></el-step>
      </el-steps>

      <div v-if="context === 'Edit'" class="button-group mb-20">
        <div class="flex">
          <el-button
            v-if="activeStep > 0"
            icon="el-icon-arrow-left"
            type="default"
            @click="stepBack"
            >{{ stepBackBtnLabel }}
          </el-button>

          <div class="box right">
            <el-button
              v-if="stepForwardBtnLabel"
              type="default"
              @click="stepForward"
              >{{ stepForwardBtnLabel }}
              <i class="el-icon-arrow-right el-icon-right"></i
            ></el-button>
          </div>
        </div>

        <el-button v-if="canStepForward" type="default" @click="stepForward"
          >Refill Config <i class="el-icon-arrow-right el-icon-right"></i
        ></el-button>
      </div>

      <div id="step-1" v-if="activeStep == 0" v-loading="processing">
        <div class="inline-form-group">
          <el-col :span="12">
            <el-input v-model="form.name" placeholder="Name">
              <template slot="prefix">Name</template>
            </el-input>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="11">
            <dads-select
              placeholder="Select Caller Id Number"
              v-model="form.callerIdNumber"
              filterable
              clearable
              remote
              :remote-method="remoteSearchCidNums"
            >
              <el-option
                v-for="(item, i) in callerIdNumberOptions"
                :key="i"
                :label="item.label | formatNumber"
                :value="item.label"
              />
              <template slot="prefix">Caller Id Number</template>
            </dads-select>
          </el-col>
        </div>

        <div class="inline-form-group">
          <el-col :span="12">
            <el-input v-model="form.npi" placeholder="NPI">
              <template slot="prefix">NPI</template>
            </el-input>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="11">
            <el-input v-model="form.ncpdp" placeholder="NCPDP">
              <template slot="prefix">NCPDP</template>
            </el-input>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-col :span="12">
            <dads-select
              v-model="form.branchId"
              :value="form.branchId"
              placeholder="Select branch"
              filterable
            >
              <el-option
                v-for="(item, index) in branchOptions"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
              <template slot="prefix">Branch</template>
            </dads-select>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="11">
            <DadsSelect
              clearable
              filterable
              v-model="form.timezone"
              :value="form.timezone"
              placeholder="Select time zone"
            >
              <template slot="prefix">Time zone</template>
              <el-option
                v-for="(time, index) in timezoneOptions"
                :key="index"
                :label="time.name"
                :value="time.name"
              />
            </DadsSelect>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-col :span="12">
            <dads-select
              v-model="form.businessHoursId"
              :value="form.businessHoursId"
              placeholder="Select business hours"
              filterable
            >
              <el-option
                v-for="item in businessHoursOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
              <template slot="prefix">Business Hours</template>
            </dads-select>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="11">
            <el-input v-model="form.sharedSecret" placeholder="Shared Secret">
              <template slot="prefix">Shared Secret</template>
            </el-input>
          </el-col>
        </div>
        <h2 class="form-section-header">Fax Numbers</h2>
        <dads-select
          v-model="form.faxNumbers"
          multiple
          filterable
          clearable
          remote
          :remote-method="remoteSearchFaxNums"
        >
          <el-option
            v-for="(item, i) in faxNumberOptions"
            :key="item.key"
            :label="item.label | formatNumber"
            :value="item.label"
          ></el-option>

          <template slot="prefix" style="opacity: 0">Fax numbers</template>
        </dads-select>

        <h2 class="form-section-header">Voicemail Boxes</h2>

        <dads-select v-model="form.voicemails" multiple filterable clearable>
          <el-option
            v-for="(item, i) in voicemailOptions"
            :key="i"
            :label="item.label"
            :value="item.key"
          />
          <template slot="prefix" style="opacity: 0">Voicemails</template>
        </dads-select>

        <div class="flex mt-30">
          <div class="box right">
            <el-button type="primary" @click="handleSubmit"
              >{{ context }}
            </el-button>
          </div>
        </div>
      </div>

      <div id="step-2" v-if="activeStep == 1" v-loading="processing">
        <el-checkbox v-model="configForm.identityPlayback">
          Enable Identity Playback
        </el-checkbox>

        <el-checkbox v-model="configForm.ivrBulk">
          Enable Bulk Refill (offer the multi-prescription IVR menu option)
        </el-checkbox>

        <!-- :disabled="!allReceivingOptions.length" -->
        <el-checkbox v-model="configForm.customReceiving"
          >Enable Custom Receiving
        </el-checkbox>

        <div v-if="configForm.customReceiving" v-loading="queryProcessing">
          <h2 class="form-section-header">Receiving Options</h2>

          <div
            class="option-card"
            v-for="(option, i) in configForm.receivingOptions"
            :key="i"
          >
            <div class="option-card__row">
              <el-col :span="10">
                <el-select
                  v-model="option.id"
                  placeholder="Select an Option"
                  filterable
                  @change="onOptionSelection(i, $event)"
                >
                  <el-option
                    v-for="item in allReceivingOptions"
                    :key="`${item.name}${item.id}`"
                    :label="item.name"
                    :value="item.name"
                    :disabled="item.disabled"
                  />
                  <template slot="prefix">Option</template>
                </el-select>
              </el-col>

              <el-col :span="1"></el-col>

              <el-col :span="10">
                <el-input
                  placeholder="Playback Name"
                  v-model="option.playbackName"
                  @input="normalizePlaybackName(i)"
                >
                  <template slot="prefix">Playback Name</template>
                </el-input>
              </el-col>

              <el-col :span="1"></el-col>

              <el-col :span="2">
                <el-tooltip
                  effect="dark"
                  content="Remove option"
                  placement="top"
                >
                  <el-button
                    @click="removeReceivingOption(i)"
                    icon="el-icon-delete"
                  />
                </el-tooltip>
              </el-col>
            </div>

            <!-- Promise Time Config -->
            <div class="promise-time-config">
              <div class="promise-time-config__header">
                <el-tooltip effect="dark" placement="top">
                  <div slot="content">
                    Enable to have your Agent share a time estimate or custom
                    message when a patient selects this receiving option.<br /><br /><b
                      >Dynamic</b
                    >
                    — States a time range from min/max values you set.<br /><b
                      >Fixed</b
                    >
                    — Plays back a custom message exactly as you type it.
                  </div>
                  <span class="promise-time-config__label"
                    >Promise Time <i class="el-icon-info"></i
                  ></span>
                </el-tooltip>
                <el-switch
                  :value="
                    option.promiseParams && option.promiseParams.enabled === 1
                  "
                  @change="handlePromiseTimeToggle(option, $event)"
                />
              </div>
              <template
                v-if="
                  option.promiseParams && option.promiseParams.enabled === 1
                "
              >
                <div class="inline-form-group mb-8">
                  <el-col :span="8">
                    <dads-select
                      v-model="option.promiseParams.playbackType"
                      placeholder="Select type"
                    >
                      <el-option label="Dynamic" value="dynamic"></el-option>
                      <el-option label="Fixed" value="fixed"></el-option>
                    </dads-select>
                  </el-col>
                </div>
                <div
                  v-if="option.promiseParams.playbackType === 'dynamic'"
                  class="inline-form-group"
                >
                  <el-col :span="5">
                    <el-input
                      placeholder="Min"
                      v-model.number="option.promiseParams.min"
                    >
                      <template slot="prefix">Min</template>
                    </el-input>
                  </el-col>
                  <el-col :span="1"></el-col>
                  <el-col :span="5">
                    <el-input
                      placeholder="Max"
                      v-model.number="option.promiseParams.max"
                    >
                      <template slot="prefix">Max</template>
                    </el-input>
                  </el-col>
                  <el-col :span="1"></el-col>
                  <el-col :span="6">
                    <dads-select
                      v-model="option.promiseParams.unit"
                      placeholder="Unit"
                    >
                      <el-option label="Hours" value="hours"></el-option>
                      <el-option label="Days" value="days"></el-option>
                    </dads-select>
                  </el-col>
                </div>
                <div v-if="option.promiseParams.playbackType === 'fixed'">
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="Enter the message your Agent will play for this option..."
                    v-model="option.promiseParams.playbackMessage"
                  />
                </div>
              </template>
            </div>
          </div>

          <el-button
            type="text"
            icon="el-icon-circle-plus-outline"
            @click="addReceivingOption"
            :disabled="newOptionDisabled"
          >
            Add an option
          </el-button>
        </div>

        <h2 class="form-section-header">Refill Conditions</h2>

        <el-checkbox v-model="configForm.conditionalRefill"
          >Enable conditional refill rules
        </el-checkbox>

        <div v-if="configForm.conditionalRefill">
          <el-checkbox v-model="configForm.useRefillDueLimits"
            >Prevent early refill requests
          </el-checkbox>

          <el-checkbox v-model="configForm.allowPartialRefills"
            >Allow partial refill requests
          </el-checkbox>

          <el-checkbox v-model="configForm.allowDiscontinued"
            >Allow request for discontinued rx
          </el-checkbox>

          <el-checkbox v-model="configForm.allowC2"
            >Allow Schedule 2 controlled substance
          </el-checkbox>

          <el-checkbox v-model="configForm.allowExpiredQty">
            Allow requests for expired with quantity remaining
            <el-popover placement="right" trigger="hover" width="300">
              <span class="black-text">
                If quantity is remaining and RX is expired, allow refill
                requests subject to the maximum expired days
              </span>
              <span slot="reference">
                <i class="el-icon-question" style="margin-right: 4px"></i>
              </span>
            </el-popover>
          </el-checkbox>

          <el-checkbox v-model="configForm.allowExpiredNoQty">
            Allow requests for expires with no quantity remaining
            <el-popover placement="right" trigger="hover" width="300">
              <span class="black-text">
                If no quantity is remaining, allow refill requests subject to
                the maximum expired days
              </span>
              <span slot="reference">
                <i class="el-icon-question" style="margin-right: 4px"></i>
              </span>
            </el-popover>
          </el-checkbox>

          <el-select
            v-model="configForm.maxExpiredDays"
            placeholder="Select maximum expired days"
          >
            <el-option v-for="(n, i) in 365" :key="i" :label="n" :value="n" />
            <template slot="prefix">Maximum expired days</template>
          </el-select>
        </div>

        <div class="flex mt-30">
          <div class="box right">
            <el-button type="primary" @click="editConfig"
              >Edit Config
            </el-button>
          </div>
        </div>
      </div>

      <div id="step-3" v-show="activeStep == 2">
        <el-tabs v-model="ivaActiveTab">
          <el-tab-pane label="Voice Settings" name="voiceSettings">
            <div class="voice-selection">
              <div v-loading="processingTTS">
                <h2 class="form-section-header pb-10">Agent Settings</h2>

                <el-checkbox v-model="ivaConfigForm.enableBackgroundNoise">
                  Enable background noise
                </el-checkbox>

                <el-checkbox v-model="ivaConfigForm.resistTransferRequest">
                  Offer help before transferring
                </el-checkbox>

                <el-input
                  v-model="ivaConfigForm.agentName"
                  placeholder="Name your agent"
                >
                  <template slot="prefix">Agent name</template>
                </el-input>

                <div class="inline-form-group">
                  <el-col :span="12">
                    <dads-select
                      v-model="voiceGender"
                      placeholder="Select voice gender"
                      @change="queryVoiceOptions"
                    >
                      <el-option label="Masculine" value="male" />
                      <el-option label="Feminine" value="female" />
                      <template slot="prefix">Voice</template>
                    </dads-select>
                  </el-col>
                  <el-col :span="1"></el-col>
                  <el-col :span="12">
                    <dads-select
                      v-loading="fetchingVoice"
                      v-model="ivaConfigForm.voiceId"
                      placeholder="Select Voice"
                      filterable
                    >
                      <el-option
                        v-for="(item, i) in voiceOptions"
                        :key="i"
                        :label="item.name"
                        :value="item.id"
                      />
                      <template slot="prefix">Voice</template>
                    </dads-select>
                  </el-col>
                </div>

                <div v-if="selectedVoiceDescription">
                  <h3 class="black-text mb-0">Voice Description</h3>
                  <span class="black-text" style="font-style: italic">
                    {{ selectedVoiceDescription }}
                  </span>
                </div>

                <h2 class="form-section-header">Greeting message</h2>
                <el-input
                  v-model="ivaConfigForm.agentGreeting"
                  :autosize="{ minRows: 4 }"
                  type="textarea"
                  placeholder="Enter the greeting message"
                />

                <div v-if="showGreetingResetBtn" class="flex">
                  <el-button
                    style="margin-left: auto"
                    @click="resetToDefaultGreeting"
                  >
                    Reset to Default
                  </el-button>
                </div>

                <el-tooltip placement="top" content="Preview audio">
                  <el-button
                    v-if="showPreviewBtn"
                    v-loading="processingTTS"
                    :icon="audioIsPlaying ? 'mdi mdi-pause' : 'mdi mdi-play'"
                    class="audio-play-button"
                    circle
                    type="primary"
                    @click="audioIsPlaying ? pauseFile() : playFile()"
                  />
                </el-tooltip>
              </div>
            </div>

            <h2 class="form-section-header">
              Agent Transfer Ringtone
              <el-popover placement="right" trigger="hover" width="320">
                <span class="black-text">
                  Select an alternate ringtone for calls transferred from the AI
                  Agent. This corresponds to the alternate ringtone setting on
                  your Yealink deskphone.
                </span>
                <span slot="reference">
                  <i class="el-icon-question" style="margin-left: 4px"></i>
                </span>
              </el-popover>
            </h2>
            <dads-select
              v-model="ivaConfigForm.alternativeRingtone"
              placeholder="Default ringtone"
            >
              <el-option label="Default ringtone" :value="null" />
              <el-option
                v-for="n in 10"
                :key="n"
                :label="`Ringtone ${n}`"
                :value="n"
              />
              <template slot="prefix">Ringtone</template>
            </dads-select>

            <h2 class="form-section-header">Transfer destinations</h2>
            <destination-selector
              :draggable="true"
              :showHeader="false"
              :draggableDestTypes="['EXT', 'HUNTLIST', 'QUEUE']"
              :selectedDestinations="ivaConfigForm.agentTransferDestinations"
              @destinationsSelected="onTransferDestinationsSelection"
              title=""
              :clearFields="true"
            />

            <h2 class="form-section-header">Prescriber Mailbox</h2>
            <destination-selector
              :isTerminalDestSelector="true"
              :draggable="true"
              :showHeader="false"
              :draggableDestTypes="['VOICEMAIL']"
              :selectedDestinations="ivaConfigForm.prescriberMailbox"
              @destinationsSelected="onPrescriberMailboxDestinationsSelection"
              title=""
              :clearFields="true"
            />

            <h2 class="form-section-header">After-Hours Mailbox</h2>
            <destination-selector
              :isTerminalDestSelector="true"
              :draggable="true"
              :showHeader="false"
              :draggableDestTypes="['VOICEMAIL']"
              :selectedDestinations="ivaConfigForm.afterHoursMailbox"
              @destinationsSelected="onAfterHoursMailboxDestinationSelection"
              title=""
              :clearFields="true"
            />
          </el-tab-pane>

          <el-tab-pane label="Location" name="location">
            <h2 class="form-section-header">Store information</h2>
            <el-input
              v-model="ivaConfigForm.storeName"
              placeholder="Enter store name"
            >
              <template slot="prefix">Store name</template>
            </el-input>

            <el-input
              v-model="ivaConfigForm.website"
              placeholder="Enter website"
            >
              <template slot="prefix">Website</template>
            </el-input>

            <el-input
              v-model="ivaConfigForm.contactPhone"
              placeholder="Enter phone contact"
            >
              <template slot="prefix">Phone contact</template>
            </el-input>

            <el-input
              v-model="ivaConfigForm.contactEmail"
              placeholder="Enter email contact"
            >
              <template slot="prefix">Email contact</template>
            </el-input>

            <h2 class="form-section-header">Address</h2>
            <el-input
              name="autoAddress"
              v-model="address"
              placeholder="Search for address"
            >
              <template slot="prefix">Search address</template>
            </el-input>

            <div class="address-fields" v-if="addressFieldsActive">
              <div class="inline-form-group">
                <el-col :span="8">
                  <el-input
                    v-model="addressForm.streetNum"
                    placeholder="Enter street number"
                  >
                    <template slot="prefix">Street number</template>
                  </el-input>
                </el-col>
                <el-col :span="1" />
                <el-col :span="15">
                  <el-input
                    v-model="addressForm.streetInfo"
                    placeholder="Enter street name"
                  >
                    <template slot="prefix">Street Name</template>
                  </el-input>
                </el-col>
              </div>
              <div class="inline-form-group">
                <el-col :span="8">
                  <el-select
                    v-model="addressForm.locationType"
                    placeholder="Select location type"
                    clearable
                  >
                    <template slot="prefix">Building / suite</template>
                    <el-option
                      v-for="location in locationOptions"
                      :key="location"
                      :label="location"
                      :value="location"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1" />
                <el-col :span="15">
                  <el-input
                    v-model="addressForm.locationNumber"
                    placeholder="Enter building / suite number"
                  >
                    <template slot="prefix">Building / suite number</template>
                  </el-input>
                </el-col>
              </div>
              <div class="inline-form-group">
                <el-col :span="11">
                  <el-input v-model="addressForm.city" placeholder="Enter city">
                    <template slot="prefix">City</template>
                  </el-input>
                </el-col>
                <el-col :span="1"></el-col>
                <el-col :span="5">
                  <el-input
                    v-model="addressForm.state"
                    placeholder="Enter state"
                  >
                    <template slot="prefix">State</template>
                  </el-input>
                </el-col>
                <el-col :span="1"></el-col>
                <el-col :span="6">
                  <el-input
                    v-model="addressForm.postalCode"
                    placeholder="Enter zip"
                  >
                    <template slot="prefix">Zip code</template>
                  </el-input>
                </el-col>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Additional Info" name="additionalInfo">
            <div
              class="inline-form-group"
              v-for="(item, i) in ivaConfigForm.contextSections"
              :key="i + '$(^^)$'"
            >
              <el-col :span="20">
                <el-input
                  :placeholder="`Enter section ${i + 1} title`"
                  v-model="item.name"
                  filterable
                  clearable
                  @change="slugifySectionTitle(i)"
                >
                  <template slot="prefix">Section title</template>
                </el-input>
                <el-input
                  placeholder="Enter system info"
                  v-model="item.data"
                  type="textarea"
                  :autosize="{ minRows: 10 }"
                />
              </el-col>
              <el-col :span="3" class="text-right">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="`Remove section ${i + 1}`"
                  placement="top"
                >
                  <el-button
                    class="ml-5"
                    style="float: right"
                    @click="removeContextSection(i)"
                    icon="el-icon-delete"
                  />
                </el-tooltip>
              </el-col>
            </div>
            <el-button
              type="text"
              icon="el-icon-circle-plus-outline"
              @click="addContextSection"
            >
              Add context
            </el-button>
          </el-tab-pane>
          <el-tab-pane label="Compliance" name="compliance">
            <h2 class="form-section-header">Recording Compliance</h2>
            <div class="compliance-toggle-row">
              <div class="compliance-toggle-label">
                Enforce Call Recording Message in Two-Party States
                <el-tooltip placement="right" effect="dark">
                  <div slot="content" style="max-width: 300px">
                    When this is on and recording is enabled, callers will hear a short message at the start of inbound and outbound calls letting them know the call is being recorded. This is meant to help meet two-party consent requirements in states where they apply. You will select a voice for the message when enabling this setting.
                  </div>
                  <i class="el-icon-info" style="margin-left: 6px; cursor: help"></i>
                </el-tooltip>
              </div>
              <el-switch
                :value="ivaConfigForm.recordingConsent"
                :active-value="1"
                :inactive-value="0"
                active-color="#35be8b"
                inactive-color="#f25a6b"
                @change="onRecordingConsentChange"
              />
            </div>

            <div
              v-if="ivaConfigForm.recordingConsent === 1 && ivaConfigForm.recordingMeId"
              class="compliance-current-row"
            >
              <el-tooltip placement="top" content="Preview current recording">
                <el-button
                  v-loading="complianceCurrentLoading"
                  :icon="complianceCurrentPlaying ? 'mdi mdi-pause' : 'mdi mdi-play'"
                  circle
                  type="primary"
                  size="mini"
                  @click="toggleComplianceCurrentAudio"
                />
              </el-tooltip>
              <span class="compliance-current-status">
                {{ complianceCurrentPlaying ? "Playing current recording..." : "Preview current recording" }}
              </span>
              <el-button
                type="text"
                class="compliance-change-voice"
                @click="openComplianceModal"
              >
                Change voice
              </el-button>
              <audio
                ref="complianceCurrentAudio"
                :src="complianceCurrentUrl || ''"
                style="display: none"
                @ended="complianceCurrentPlaying = false"
                @pause="complianceCurrentPlaying = false"
                @play="complianceCurrentPlaying = true"
              />
            </div>
          </el-tab-pane>

          <el-tab-pane label="Announcements" name="announcements">
            <draggable
              :key="draggableKey"
              @change="changeDraggableKey"
              v-model="announcementKeys"
            >
              <transition-group name="list" tag="div">
                <div
                  class="inline-form-group"
                  v-for="(item, i) in announcementKeys"
                  :key="i + '$(^^)$'"
                >
                  <el-col :span="18">
                    <dads-select
                      :placeholder="`Select Announcement ${i + 1}`"
                      :remote-method="
                        (query) => remoteSearchAnnouncements(query, i)
                      "
                      v-model="item.id"
                      remote
                      filterable
                      clearable
                      @change="($event) => onAnnouncementSelection($event, i)"
                    >
                      <el-option
                        v-for="(el, j) in item.options"
                        :key="j"
                        :label="el.name"
                        :value="el.id"
                      />
                    </dads-select>
                  </el-col>
                  <el-col :span="1" />
                  <el-col :span="5" class="text-right">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="`Remove Announcement ${i + 1}`"
                      placement="top"
                    >
                      <el-button
                        class="ml-5"
                        style="float: right; margin-right: 1px"
                        @click="removeAnnouncementKey(i)"
                        icon="el-icon-delete"
                      />
                    </el-tooltip>
                    <el-button icon="el-icon-rank" type="default" />
                  </el-col>
                </div>
              </transition-group>
            </draggable>
            <el-button
              type="text"
              icon="el-icon-circle-plus-outline"
              @click="addAnnouncementKey"
            >
              Add Announcement
            </el-button>
          </el-tab-pane>
          <el-tab-pane label="Tools" name="tools">
            <h2 class="form-section-header">Compound Auto Transfer</h2>
            <el-switch
              v-model="ivaConfigForm.autoTransferCompounding"
              :active-text="ivaConfigForm.autoTransferCompounding?'Enabled':'Disabled'"
            />
            <div v-if="ivaConfigForm.autoTransferCompounding">
              <h3 class="form-section-header">Transfer destination</h3>
              <destination-selector
                :isTerminalDestSelector="true"
                :draggable="true"
                :showHeader="false"
                :draggableDestTypes="['EXT', 'HUNTLIST', 'QUEUE']"
                :maxDests="1"
                :selectedDestinations="ivaConfigForm.autoTransferCompoundingDestination"
                @destinationsSelected="onAutoTransferCompoundingDestSelection"
                title=""
                :clearFields="true"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-form>

    <!-- Recording Consent Voice Modal -->
    <el-dialog
      title="Select Recording Consent Voice"
      :visible.sync="complianceModalVisible"
      width="500px"
      :before-close="cancelComplianceModal"
      append-to-body
    >
      <p style="color: #606266; font-size: 13px; margin-bottom: 16px;">
        Select a voice for the recording consent message. The following message will be played to callers:
      </p>
      <p style="font-style: italic; color: #909399; font-size: 13px; margin-bottom: 20px;">
        "This call is being recorded for compliance and quality purposes. By staying on the line, you consent to the recording."
      </p>
      <div class="inline-form-group">
        <el-col :span="11">
          <span class="compliance-modal-label">Voice Gender</span>
          <dads-select
            v-model="complianceVoiceGender"
            placeholder="Select voice gender"
            @change="onComplianceGenderChange"
          >
            <el-option label="Masculine" value="male" />
            <el-option label="Feminine" value="female" />
          </dads-select>
        </el-col>
        <el-col :span="1"></el-col>
        <el-col :span="12">
          <span class="compliance-modal-label">Voice</span>
          <dads-select
            v-loading="complianceVoiceFetching"
            v-model="complianceVoiceId"
            placeholder="Select Voice"
            filterable
            @change="onComplianceVoiceChange"
          >
            <el-option
              v-for="(item, i) in complianceVoiceOptions"
              :key="i"
              :label="item.name"
              :value="item.id"
            />
          </dads-select>
        </el-col>
      </div>

      <div class="compliance-preview-row">
        <el-button
          :disabled="!complianceVoiceId || compliancePreviewLoading"
          :loading="compliancePreviewLoading"
          icon="mdi mdi-volume-high"
          @click="previewComplianceVoice"
        >
          Preview
        </el-button>
        <audio
          v-if="compliancePreviewUrl"
          :src="compliancePreviewUrl"
          controls
          class="compliance-preview-audio"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelComplianceModal">Cancel</el-button>
        <el-button
          type="primary"
          :disabled="!complianceVoiceId"
          :loading="processingConsentAudio"
          @click="saveComplianceVoice"
        >
          Save
        </el-button>
      </span>
    </el-dialog>
  </DialogComponent>
</template>

<script>
import { debounce } from "lodash";
import DadsSelect from "@/components/select";
import { phoneNumberFormatter } from "@/globals/globals";
import OmniaTimeSelect from "@/components/OmniaTimeSelect.vue";
import DialogComponent from "@/components/CustomModalComponent";
import TimeRangeSelector from "@/components/TimeRangeSelector.vue";
import feathersClient, { apiV2Host } from "@/feathers/feathers-client";
import DestinationSelector from "@/components/DestinationSelector.vue";
import Draggable from "vuedraggable";
import LibertyRxForm from "@/views/pages/pharmacy-agents/components/agent-forms/LibertyRxForm.vue";

export default {
  name: "LibertyRxForm",

  props: {
    context: { required: true },
    visible: { required: true },
    clearForm: { required: true },
    typeOptions: { required: true },
    selectedAgent: { required: true },
    branchOptions: { required: true }
  },

  components: {
    LibertyRxForm,
    Draggable,
    DadsSelect,
    DialogComponent,
    OmniaTimeSelect,
    TimeRangeSelector,
    DestinationSelector
  },

  data() {
    return {
      hidePopover: false,
      agent: null,
      activeStep: 0,
      processing: false,
      queryProcessing: false,
      allReceivingOptions: [],
      fieldsChanged: false,
      callerIdNumberQuery: "",
      callerIdNumberOptions: [],
      fetchingVoice: false,
      voiceGender: null,
      voiceOptions: [],
      toneOptions: [],
      mannerismOptions: [],
      languageOptions: [
        {
          label: "English",
          value: "en"
        },
        {
          label: "Spanish",
          value: "es"
        }
      ],
      timezoneOptions: [],
      businessHoursOptions: [],
      ivaActiveTab: "voiceSettings",

      faxNumberOptions: [],
      faxNumberQuery: null,
      voicemailOptions: [],

      autocomplete: null,
      address: "",
      addressFieldsActive: false,
      locationOptions: ["BLDG", "FL", "STE", "APT"],
      addressForm: {
        streetNum: "",
        streetInfo: "",
        city: "",
        state: "",
        postalCode: "",
        locationType: "",
        locationNumber: ""
      },

      form: {
        tenantId: null,
        name: "",
        npi: "",
        ncpdp: "",
        callerIdNumber: undefined,
        timezone: undefined,
        faxNumbers: [],
        voicemails: [],
        branchId: null,
        businessHoursId: null,
        pms: "LibertyRx",
        sharedSecret: undefined
      },

      configForm: {
        conditionalRefill: false,
        allowC2: false,
        allowExpiredQty: false,
        allowExpiredNoQty: false,
        useRefillDueLimits: false,
        allowPartialRefills: false,
        maxExpiredDays: 30,
        customReceiving: false,
        receivingOptions: [],
        allowDiscontinued: false,
        identityPlayback: true,
        ivrBulk: false,
        pms: "LibertyRx"
      },
      ivaConfigForm: {
        voiceId: null,
        storeName: null,
        website: null,
        contactPhone: null,
        contactEmail: null,
        agentName: null,
        enableBackgroundNoise: true,
        resistTransferRequest: false,
        agentGreeting: "",
        agentTransferDestinations: [],
        prescriberMailbox: [],
        afterHoursMailbox: [],
        contextSections: [],
        announcementsIds: [],
        alternativeRingtone: null,
        autoTransferCompounding: false,
        autoTransferCompoundingDestination: [],
        recordingConsent: 0,
        recordingMeId: null,
        pms: "LibertyRx"
      },
      isNewVoice: false,
      audioEl: null,
      bgAudioEl: null,
      audioIsPlaying: false,
      voiceAudioBlob: null,
      processingTTS: false,
      complianceModalVisible: false,
      complianceVoiceGender: null,
      complianceVoiceId: null,
      complianceVoiceOptions: [],
      complianceVoiceFetching: false,
      compliancePrefillToken: 0,
      processingConsentAudio: false,
      compliancePreviewUrl: null,
      compliancePreviewLoading: false,
      complianceCurrentUrl: null,
      complianceCurrentLoading: false,
      complianceCurrentPlaying: false,

      voiceSelection: "builtIn",

      draggableKey: "",
      announcementKeys: [
        {
          id: null,
          options: [],
          value: null
        }
      ],
      announcementOptions: null
    };
  },
  async created() {
    await this.getDefaultBranch();
    await this.getBusinessHours();
  },

  computed: {
    ivaDefaultGreeting() {
      return `Hi, I'm your pharmacy agent. I can help you refill your prescriptions, check their status or answer any general pharmacy questions. What's your name and date of birth?`;
    },

    stepForwardBtnLabel() {
      if (this.activeStep === 1) {
        return "Agent Config";
      }

      return null;
    },

    stepBackBtnLabel() {
      if (this.activeStep === 1) {
        return "Location Settings";
      }

      if (this.activeStep === 2) {
        return "Refill Config";
      }

      if (this.activeStep === 3) {
        return "Agent Config";
      }
    },

    enableBackgroundNoise() {
      return this.ivaConfigForm.enableBackgroundNoise;
    },

    voiceId() {
      return this.ivaConfigForm.voiceId;
    },

    agentGreeting() {
      return this.ivaConfigForm.agentGreeting;
    },

    showPreviewBtn() {
      return this.voiceId && this.agentGreeting;
    },

    showGreetingResetBtn() {
      return this.ivaDefaultGreeting !== this.ivaConfigForm.agentGreeting;
    },

    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    modalTitle() {
      if (this.activeStep === 0) {
        return `${
          this.context === "Create" ? this.context : "View / Edit"
        } LibertyRx Agent`;
      }

      return `${
        this.context === "Create" ? "Configure" : "View / Configure"
      } LibertyRx Agent`;
    },

    canStepForward() {
      return (
        this.activeStep === 0 &&
        (!this.fieldsChanged || this.context === "Edit")
      );
    },

    newOptionDisabled() {
      if (this.allReceivingOptions.length === 0) return;
      const lastIdx = this.configForm.receivingOptions.length - 1;
      const { id, name, playbackName } =
        this.configForm.receivingOptions[lastIdx];

      const selectedOptions = this.allReceivingOptions.filter(
        (op) => op.disabled
      );
      const isAllOptionsSelected =
        selectedOptions.length === this.allReceivingOptions.length;

      return !id || !name || !playbackName || isAllOptionsSelected;
    },

    selectedVoiceDescription() {
      const voice = this.voiceOptions.find(
        (voice) => voice.id === this.voiceId
      );
      return voice ? voice.description : null;
    }
  },

  watch: {
    voiceSelection() {
      this.isNewVoice = true;
    },

    voiceId() {
      this.isNewVoice = true;
    },

    agentGreeting() {
      this.isNewVoice = true;
    },

    isNewVoice(isNewVoice) {
      if (isNewVoice) {
        this.pauseFile();
      }
    },

    enableBackgroundNoise() {
      this.pauseFile();
    },

    selectedTenant() {
      this.getCallerIdNumberOptions();
    },

    async visible(visible) {
      if (visible) {
        this.resetToDefaultGreeting();
        this.getFaxNumberOptions();
        this.getVoicemailOptions();
        this.getDefaultBranch();
        this.getAnnouncementOptions();
        await this.getBusinessHours();
      }
    },

    clearForm(clear) {
      if (clear) {
        this.clearFields();
      }
    },

    activeStep(step) {
      if (step === 1 && this.context === "Create") {
        this.queryReceivingOptions();
      }
    },

    form: {
      deep: true,
      handler: debounce(function determineFieldsChanged(form) {
        if (!this.agent) {
          this.fieldsChanged = false;
        }

        for (let key in this.agent) {
          if (key === "faxNumbers" || key === "voicemails") {
            this.fieldsChanged =
              key in form &&
              (this.agent[key] || "").toString() !==
                (form[key] || []).join(",");
          } else {
            this.fieldsChanged = key in form && this.agent[key] !== form[key];
          }

          if (this.fieldsChanged) break;
        }
      }, 500)
    },

    async selectedAgent(agent) {
      if (agent) {
        this.agent = agent;

        const {
          receivingOptions,
          faxNumbers,
          faxNumberOptions,
          address,
          enableBackgroundNoise,
          resistTransferRequest,
          voice,
          identityPlayback,
          announcements
        } = agent;

        this.setBranchId(agent.branchId);

        this.configForm = {
          ...this.configForm,
          identityPlayback: identityPlayback === 1
        };

        if (address) {
          this.addressFieldsActive = true;

          for (const key in address) {
            if (key in this.addressForm) {
              this.addressForm[key] = address[key];
            }
          }

          if (address.location) {
            const [locationType, locationNumber] = address.location.split(" ");
            this.addressForm.locationType = locationType;
            this.addressForm.locationNumber = locationNumber;
          }
        }

        if (faxNumberOptions && faxNumberOptions.length) {
          this.faxNumberOptions = faxNumberOptions;
        }

        for (let key of Object.keys(agent)) {
          if (key in this.form && key !== "faxNumbers") {
            this.form[key] = agent[key];
          }

          if (
            key in this.ivaConfigForm &&
            agent[key] !== undefined &&
            agent[key] !== null
          ) {
            this.ivaConfigForm[key] = agent[key];
          }

          if (key in this.configForm && key !== "receivingOptions") {
            this.configForm[key] = [1, 0].includes(agent[key])
              ? agent[key] === 1
              : agent[key];
          }
        }

        // Parse alternativeRingtone from API format ("ALTERNATERINGTONE3" -> 3)
        const ringtoneRaw = agent.alternativeRingtone;
        this.ivaConfigForm.alternativeRingtone =
          typeof ringtoneRaw === "string"
            ? Number(ringtoneRaw.replace("ALTERNATERINGTONE", "")) || null
            : null;

        this.ivaConfigForm.enableBackgroundNoise = !!enableBackgroundNoise;
        this.ivaConfigForm.resistTransferRequest = !!resistTransferRequest;

        if (
          agent.agentTransferDestinations &&
          agent.agentTransferDestinations.length
        ) {
          try {
            this.ivaConfigForm.agentTransferDestinations =
              agent.agentTransferDestinations.map((dest) => ({
                id: dest.id,
                type: dest.type,
                options: [
                  {
                    id: dest.id,
                    name: dest.name,
                    number: dest.number
                  }
                ]
              }));
          } catch (e) {
            this.ivaConfigForm.agentTransferDestinations = [];
          }
        }

        if (agent.prescriberMailbox && agent.prescriberMailbox.length) {
          try {
            this.ivaConfigForm.prescriberMailbox = agent.prescriberMailbox.map(
              (dest) => ({
                id: dest.id,
                type: dest.type,
                options: [
                  {
                    id: dest.id,
                    fullName: dest.name,
                    mailbox: dest.number
                  }
                ]
              })
            );
          } catch (e) {
            this.ivaConfigForm.prescriberMailbox = [];
          }
        }

        if (agent.afterHoursMailbox && agent.afterHoursMailbox.length) {
          try {
            this.ivaConfigForm.afterHoursMailbox = agent.afterHoursMailbox.map(
              (dest) => ({
                id: dest.id,
                type: dest.type,
                options: [
                  {
                    id: dest.id,
                    fullName: dest.name,
                    mailbox: dest.number
                  }
                ]
              })
            );
          } catch (e) {
            this.ivaConfigForm.afterHoursMailbox = [];
          }
        }

        if (agent.autoTransferCompounding !== undefined) {
          this.ivaConfigForm.autoTransferCompounding = !!agent.autoTransferCompounding;
        }
        if (agent.autoTransferCompoundingDestination && agent.autoTransferCompoundingDestination.length) {
          try {
            this.ivaConfigForm.autoTransferCompoundingDestination = agent.autoTransferCompoundingDestination.map(
              (dest) => ({
                id: dest.id,
                type: dest.type,
                options: [
                  {
                    id: dest.id,
                    name: dest.name,
                    number: dest.number
                  }
                ]
              })
            );
          } catch (e) {
            this.ivaConfigForm.autoTransferCompoundingDestination = [];
          }
        }

        if (faxNumbers && faxNumbers.length) {
          this.form.faxNumbers = faxNumbers.split(",");
        }

        if (receivingOptions && receivingOptions.length) {
          this.configForm.receivingOptions = receivingOptions.map(
            ({ id, name, playbackName, promiseParams }) => ({
              id,
              name,
              playbackName,
              promiseParams: promiseParams || {
                enabled: 0,
                playbackType: "dynamic",
                min: 1,
                max: null,
                unit: "hours",
                playbackMessage: ""
              }
            })
          );
        } else {
          this.configForm.receivingOptions = [
            {
              id: null,
              name: "",
              playbackName: "",
              promiseParams: {
                enabled: 0,
                playbackType: "dynamic",
                min: 1,
                max: null,
                unit: "hours",
                playbackMessage: ""
              }
            }
          ];
        }

        // Voice settings
        if (voice) {
          this.voiceGender = voice ? voice.gender : null;

          await this.queryVoiceOptions();
          const voiceExists = this.voiceOptions.find(
            (item) => item.id === voice.id
          );

          if (!voiceExists) {
            this.voiceOptions = [...this.voiceOptions, voice];
          }
        }

        if (announcements && announcements.length) {
          this.announcementKeys = [];
          for (let i = 0; i < announcements.length; i++) {
            const announcement = announcements[i];
            this.announcementKeys.push({
              id: announcement.id,
              options: [
                {
                  id: announcement.id,
                  name: announcement.name,
                  description: announcement.description
                }
              ],
              value: {
                id: announcement.id,
                name: announcement.name,
                description: announcement.description
              }
            });
          }
        }

        this.queryReceivingOptions();
      }
    },

    callerIdNumberQuery: {
      handler: debounce(function searchCidNums() {
        this.getCallerIdNumberOptions();
      }, 500)
    },

    faxNumberQuery: {
      handler: debounce(function () {
        this.getFaxNumberOptions();
      }, 500)
    }
  },

  methods: {
    stepBack() {
      this.activeStep--;
    },

    stepForward() {
      this.activeStep++;
    },

    goToStep(step) {
      if (
        this.activeStep === step ||
        this.context === "Create" ||
        this.processing
      )
        return;
      this.activeStep = step;
    },

    remoteSearchCidNums(query) {
      this.callerIdNumberQuery = query;
    },

    remoteSearchFaxNums(query) {
      this.faxNumberQuery = query;
    },

    getCallerIdNumberOptions() {
      const didParams = {
        query: {
          tenantId: this.selectedTenant.id,
          allowEmergency: "",
          $limit: 10
        }
      };

      if (this.callerIdNumberQuery && this.callerIdNumberQuery.length) {
        didParams.query.$or = [
          { number: { $like: `%${this.callerIdNumberQuery}%` } }
        ];
      }

      feathersClient
        .service("dids")
        .find(didParams)
        .then((res) => {
          this.callerIdNumberOptions = [];
          this.callerIdNumberOptions = res.map((item) => ({
            key: item.id,
            label: item.number
          }));
        });
    },

    getFaxNumberOptions() {
      const didParams = {
        query: {
          tenantId: this.selectedTenant.id,
          $limit: 10,
          $sort: { number: 1 }
        }
      };

      if (this.faxNumberQuery && this.faxNumberQuery.length) {
        didParams.query.$or = [
          { number: { $like: `%${this.faxNumberQuery}%` } }
        ];
      }

      feathersClient
        .service("dids")
        .find(didParams)
        .then((res) => {
          // Preserve current selection
          const currentSelection = this.faxNumberOptions.filter((item) =>
            this.form.faxNumbers.includes(item.label)
          );

          // Merge New Options
          const newOptions = res
            .filter((item) => !this.form.faxNumbers.includes(item.number))
            .map((item) => ({
              key: item.id,
              label: item.number
            }));

          this.faxNumberOptions = [...currentSelection, ...newOptions];
        });
    },

    getVoicemailOptions() {
      feathersClient
        .service("voicemails")
        .find({
          query: {
            tenantId: this.selectedTenant.id
          }
        })
        .then((res) => {
          this.voicemailOptions = res.map((item) => ({
            key: item.id,
            label: `${item.mailbox} - ${item.fullName}`
          }));
        });
    },

    async queryReceivingOptions() {
      const url = `${apiV2Host}/integrations/liberty-rx/agents/receiving-options/${this.agent.id}`;

      try {
        this.queryProcessing = true;
        this.allReceivingOptions = [];

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.accessToken
          }
        });

        this.queryProcessing = false;
        if (!response.ok) {
          this.configForm.customReceiving = false;
          return;
        }

        const options = await response.json();

        this.allReceivingOptions = options.map((option) => {
          return {
            ...option,
            disabled: false
          };
        });
      } catch (e) {
        this.queryProcessing = false;
        console.error(e);
      }
    },

    handlePromiseTimeToggle(option, val) {
      this.$set(option, "promiseParams", {
        enabled: val ? 1 : 0,
        playbackType: "dynamic",
        min: 1,
        max: null,
        unit: "hours",
        playbackMessage: ""
      });
    },

    async setBranchId(branchId) {
      if (branchId && branchId !== 0) {
        this.form.branchId = branchId;
        return;
      }
      try {
        const res = await feathersClient.service("branches").find({
          query: {
            tenantId: this.selectedTenant.id,
            default: 1
          }
        });
        const [defaultBranch] = res;
        if (defaultBranch) {
          this.form.branchId = defaultBranch.id;
        }
      } catch (err) {
        console.error("Failed to fetch default branch", err);
        this.form.branchId = null;
      }
    },

    handleSubmit() {
      if (this.context === "Create") {
        this.createOperation();
        return;
      }

      this.editOperation();
    },

    buildAddress() {
      const {
        streetNum,
        streetInfo,
        city,
        state,
        postalCode,
        locationType,
        locationNumber
      } = this.addressForm;

      const address = {
        streetNum,
        streetInfo,
        location: "",
        city,
        state,
        postalCode
      };

      if (locationType && locationNumber) {
        address.location = `${locationType} ${locationNumber}`;
      }

      return address;
    },

    createOperation() {
      this.form.tenantId = this.selectedTenant.id;

      const createBody = this.setupFormForAgentType();

      this.$confirm(`Create LibertyRx Agent?`, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(async () => {
          this.processing = true;
          try {
            const res = await fetch(`${apiV2Host}/admin/pharmacy/agents/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
                Accept: "application/json"
              },
              body: JSON.stringify(createBody)
            });

            this.processing = false;
            const response = await res.json();

            if (!res.ok) {
              const { name, message, validationErrors } = response;
              this.$notify({
                title: name,
                message:
                  validationErrors && validationErrors.length
                    ? validationErrors[0]
                    : message,
                type: "error"
              });

              return;
            }

            this.agent = response;

            this.activeStep += 1;

            this.$notify({
              type: "success",
              title: "Success",
              message: "Created successfully"
            });
          } catch (err) {
            this.processing = false;
          }
        })
        .catch(() => true);
    },

    async patchAgent(body) {
      return fetch(`${apiV2Host}/admin/pharmacy/agents/${this.agent.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
          Accept: "application/json"
        },
        body: JSON.stringify(body)
      });
    },

    setupFormForAgentType(type) {
      const form = { ...this.form };

      if (!form.businessHoursId) delete form.businessHoursId;
      if (!form.sharedSecret) delete form.sharedSecret;
      if (type === "edit") {
        if (form.tenantId) delete form.tenantId;
        if (!form.callerIdNumber) delete form.callerIdNumber;
      }
      return form;
    },

    setupConfigForAgentType() {
      return { ...this.configForm };
    },

    setupIVAForAgentType() {
      return { ...this.ivaConfigForm };
    },

    editOperation() {
      this.$confirm(`Edit LibertyRx Agent?`, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(async () => {
          try {
            this.processing = true;

            const editBody = this.setupFormForAgentType("edit");

            const res = await this.patchAgent(editBody);
            const response = await res.json();

            this.processing = false;

            if (!res.ok) {
              const { name, message, validationErrors } = response;
              this.$notify({
                title: name,
                message:
                  validationErrors && validationErrors.length
                    ? validationErrors[0]
                    : message,
                type: "error"
              });
              return;
            }

            this.activeStep++;
            this.fieldsChanged = false;
            this.agent = response;

            this.$notify({
              type: "success",
              title: "Success",
              message: "Edited successfully"
            });
          } catch (err) {
            console.dir(err);
            this.processing = false;
          }
        })
        .catch(() => true);
    },

    editConfig() {
      this.$confirm(`Configure LibertyRx Agent?`, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(async () => {
          try {
            const configBody = this.setupConfigForAgentType();

            //map over receiving options and remove null block(s)
            configBody.receivingOptions = configBody.receivingOptions
              .filter((option) => !!option.id)
              .map((option) => ({
                ...option,
                promiseParams: option.promiseParams
                  ? {
                      ...option.promiseParams,
                      enabled: Number(option.promiseParams.enabled) || 0
                    }
                  : option.promiseParams
              }));

            for (let key in configBody) {
              if (typeof configBody[key] === "boolean") {
                configBody[key] = configBody[key] ? 1 : 0;
              }
            }

            if (
              configBody.customReceiving &&
              !(
                configBody.receivingOptions &&
                configBody.receivingOptions.length
              )
            ) {
              this.$notify({
                type: "error",
                title: "Bad Request",
                message: "receivingOptions is required!"
              });
              return;
            }

            this.processing = true;

            const res = await this.patchAgent(configBody);
            const response = await res.json();

            if (!res.ok) {
              this.processing = false;
              const { name, message, validationErrors } = response;
              this.$notify({
                title: name,
                message:
                  validationErrors && validationErrors.length
                    ? validationErrors[0]
                    : message,
                type: "error"
              });
              return;
            }

            this.agent = response;
            this.processing = false;

            if (this.context === "Create") {
              this.activeStep++;
            }

            this.$notify({
              type: "success",
              title: "Success",
              message: `LibertyRx Agent configured successfully`
            });
          } catch (err) {
            this.processing = false;
          }
        })
        .catch(() => true);
    },

    editIVAConfig() {
      this.$confirm(`Configure Pharmacy Agent for LibertyRx?`, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(async () => {
          try {
            const configBody = this.setupIVAForAgentType();

            configBody.announcementsIds = this.announcementKeys
              .filter((item) => item.id !== null)
              .map((item) => item.id);

            const { enableBackgroundNoise, resistTransferRequest, agentGreeting } =
              this.ivaConfigForm;

            configBody.enableBackgroundNoise = enableBackgroundNoise ? 1 : 0;
            configBody.resistTransferRequest = resistTransferRequest ? 1 : 0;

            if (!agentGreeting) {
              configBody.agentGreeting = this.ivaDefaultGreeting;
            }

            if (this.addressFieldsActive) {
              configBody.address = this.buildAddress();
            }

            // transfer destinations
            if (
              configBody.agentTransferDestinations &&
              configBody.agentTransferDestinations.length
            ) {
              configBody.agentTransferDestinations =
                configBody.agentTransferDestinations.map((item) => {
                  const option = item.options.find(
                    (option) => option.id === item.id
                  );
                  return {
                    id: item.id,
                    type: item.type,
                    name: option.name,
                    number: option.number
                  };
                });
            }

            // prescriber mailbox
            if (
              configBody.prescriberMailbox &&
              configBody.prescriberMailbox.length
            ) {
              configBody.prescriberMailbox = configBody.prescriberMailbox.map(
                (item) => {
                  const option = item.options.find(
                    (option) => option.id === item.id
                  );
                  return {
                    id: item.id,
                    type: item.type,
                    name: option.fullName,
                    number: this.formatMailboxNumber(option.mailbox)
                  };
                }
              );
            }

            if (
              configBody.afterHoursMailbox &&
              configBody.afterHoursMailbox.length
            ) {
              configBody.afterHoursMailbox = configBody.afterHoursMailbox.map(
                (item) => {
                  const option = item.options.find(
                    (option) => option.id === item.id
                  );
                  return {
                    id: item.id,
                    type: item.type,
                    name: option.fullName,
                    number: this.formatMailboxNumber(option.mailbox)
                  };
                }
              );
            }

            // compound auto transfer
            configBody.autoTransferCompounding = configBody.autoTransferCompounding ? 1 : 0;
            if (configBody.autoTransferCompounding) {
              const dests = configBody.autoTransferCompoundingDestination;
              if (dests && dests.length && dests[0].id) {
                const item = dests[0];
                const option = item.options.find(
                  (option) => option.id === item.id
                );
                configBody.autoTransferCompoundingDestination = [{
                  id: item.id,
                  type: item.type,
                  name: option.name,
                  number: option.number
                }];
              }
            } else {
              configBody.autoTransferCompoundingDestination = null;
            }

            this.processing = true;

            const res = await this.patchAgent(configBody);
            const response = await res.json();

            if (!res.ok) {
              this.processing = false;
              const { name, message, validationErrors } = response;
              this.$notify({
                title: name,
                message:
                  validationErrors && validationErrors.length
                    ? validationErrors[0]
                    : message,
                type: "error"
              });
              return;
            }

            this.agent = response;
            this.processing = false;
            this.cancelOperation();

            this.$notify({
              type: "success",
              title: "Success",
              message: `Pharmacy Agent for LibertyRx configured successfully`
            });
          } catch (err) {
            console.dir({ err });
            this.processing = false;
          }
        })
        .catch(() => true);
    },

    formatMailboxNumber(mailbox) {
      if (!mailbox) return "";
      return mailbox.startsWith("*") ? mailbox : "*" + mailbox;
    },

    onTransferDestinationsSelection(destinations) {
      if (
        !destinations ||
        destinations.length === 0 ||
        (destinations.length === 1 && destinations[0].id === null)
      ) {
        this.ivaConfigForm.agentTransferDestinations = [];
      } else {
        this.ivaConfigForm.agentTransferDestinations = destinations;
      }
    },

    onPrescriberMailboxDestinationsSelection(destinations) {
      if (
        !destinations ||
        destinations.length === 0 ||
        (destinations.length === 1 && destinations[0].id === null)
      ) {
        this.ivaConfigForm.prescriberMailbox = [];
      } else {
        this.ivaConfigForm.prescriberMailbox = destinations;
      }
    },

    onAfterHoursMailboxDestinationSelection(destinations) {
      if (
        !destinations ||
        destinations.length === 0 ||
        (destinations.length === 1 && destinations[0].id === null)
      ) {
        this.ivaConfigForm.afterHoursMailbox = [];
      } else {
        this.ivaConfigForm.afterHoursMailbox = destinations;
      }
    },

    onAutoTransferCompoundingDestSelection(destinations) {
      if (
        !destinations ||
        destinations.length === 0 ||
        (destinations.length === 1 && destinations[0].id === null)
      ) {
        this.ivaConfigForm.autoTransferCompoundingDestination = [];
      } else {
        this.ivaConfigForm.autoTransferCompoundingDestination = destinations;
      }
    },

    resetToDefaultGreeting() {
      this.ivaConfigForm.agentGreeting = this.ivaDefaultGreeting;
    },

    onBusinessHoursSelection(index, { start, end }) {
      this.ivaConfigForm.ivaBusinessHours[index].opens = start;
      this.ivaConfigForm.ivaBusinessHours[index].closes = end;
    },

    onHolidayScheduleSelection(index, { start, end }) {
      this.ivaConfigForm.ivaHolidaySchedule[index].opens = start;
      this.ivaConfigForm.ivaHolidaySchedule[index].closes = end;
    },

    addReceivingOption() {
      this.configForm.receivingOptions.push({
        id: null,
        name: "",
        playbackName: "",
        promiseParams: {
          enabled: 0,
          playbackType: "dynamic",
          min: 1,
          max: null,
          unit: "hours",
          playbackMessage: ""
        }
      });
    },

    addContextSection() {
      this.ivaConfigForm.contextSections.push({
        id: "",
        name: "",
        data: ""
      });
    },

    removeContextSection(idx) {
      this.ivaConfigForm.contextSections.splice(idx, 1);
    },

    slugifySectionTitle(idx) {
      const section = this.ivaConfigForm.contextSections[idx];

      const slug = section.name
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/--+/g, "-")
        .trim();

      this.ivaConfigForm.contextSections[idx].id = slug;
    },

    removeReceivingOption(idx) {
      const [removedOption] = this.configForm.receivingOptions.splice(idx, 1);
      if (removedOption.id) {
        const optionIdx = this.allReceivingOptions.findIndex(
          (op) => op.id === removedOption.id
        );
        if (optionIdx !== -1) {
          this.allReceivingOptions[optionIdx].disabled = false;
        }
      }

      if (this.configForm.receivingOptions.length === 0) {
        this.addReceivingOption();
      }
    },

    onOptionSelection(idx, optionId) {
      const optionIdx = this.allReceivingOptions.findIndex(
        (op) => op.name === optionId
      );
      this.allReceivingOptions[optionIdx].disabled = true;
      const option = this.allReceivingOptions[optionIdx];
      const { name, playbackName } = option;
      this.configForm.receivingOptions[idx].name = name;
      this.configForm.receivingOptions[idx].playbackName = playbackName || name;
    },
    async getDefaultBranch() {
      try {
        if (!this.form.branchId) {
          const res = await feathersClient.service("branches").find({
            query: {
              tenantId: this.selectedTenant.id,
              default: 1
            }
          });

          const [defaultBranch] = res;
          if (defaultBranch) {
            this.form.branchId = defaultBranch.id;
          }
        }
      } catch (err) {
        console.error("Failed to fetch default branch", err);
      }
    },
    async getBusinessHours() {
      try {
        const res = await feathersClient.service("conditions").find({
          query: {
            tenantId: this.selectedTenant.id,
            type: "BUSINESSHOUR",
            $sort: { name: 1 }
          }
        });
        this.businessHoursOptions = res;
      } catch (err) {
        console.error("Failed to fetch business hours", err);
      }
    },

    cancelOperation() {
      this.activeStep = 0;
      this.$emit("cancelOperation", this.agent);
    },

    clearFields() {
      this.agent = null;
      this.allReceivingOptions = [];
      this.activeStep = 0;
      this.fieldsChanged = false;
      this.callerIdNumberQuery = "";
      this.faxNumberQuery = null;
      this.ivaActiveTab = "voiceSettings";
      this.voiceSelection = "builtIn";
      this.voiceGender = null;
      this.isNewVoice = false;

      this.draggableKey = "";
      this.announcementKeys = [
        {
          id: null,
          options: [],
          value: null
        }
      ];

      this.addressFieldsActive = false;
      this.address = "";
      this.addressForm = {
        streetNum: "",
        streetInfo: "",
        city: "",
        state: "",
        postalCode: "",
        locationType: "",
        locationNumber: ""
      };

      this.form = {
        tenantId: null,
        name: "",
        npi: "",
        ncpdp: "",
        callerIdNumber: undefined,
        timezone: undefined,
        faxNumbers: [],
        voicemails: [],
        branchId: null,
        businessHoursId: null,
        pms: "LibertyRx",
        sharedSecret: undefined
      };
      this.getDefaultBranch();

      this.configForm = {
        conditionalRefill: false,
        allowC2: false,
        allowExpiredQty: false,
        allowExpiredNoQty: false,
        useRefillDueLimits: false,
        allowPartialRefills: false,
        maxExpiredDays: 30,
        customReceiving: false,
        receivingOptions: [
          {
            id: null,
            name: "",
            playbackName: "",
            promiseParams: {
              enabled: 0,
              playbackType: "dynamic",
              min: 1,
              max: null,
              unit: "hours",
              playbackMessage: ""
            }
          }
        ],
        allowDiscontinued: false,
        identityPlayback: true,
        ivrBulk: false,
        pms: "LibertyRx"
      };

      this.ivaConfigForm = {
        voiceId: null,
        storeName: null,
        website: null,
        contactPhone: null,
        contactEmail: null,
        agentName: null,
        enableBackgroundNoise: true,
        resistTransferRequest: false,
        agentGreeting: "",
        agentTransferDestinations: [],
        prescriberMailbox: [],
        afterHoursMailbox: [],
        contextSections: [],
        announcementsIds: [],
        alternativeRingtone: null,
        autoTransferCompounding: false,
        autoTransferCompoundingDestination: [],
        recordingConsent: 0,
        recordingMeId: null,
        pms: "LibertyRx"
      };

      this.complianceModalVisible = false;
      this.complianceVoiceGender = null;
      this.complianceVoiceId = null;
      this.complianceVoiceOptions = [];
      this.revokeCompliancePreview();
      this.complianceCurrentUrl = null;
      this.complianceCurrentPlaying = false;
    },

    queryTimezoneOptions() {
      feathersClient
        .service("timezones")
        .find({
          query: {
            $sort: { name: 1 }
          }
        })
        .then((res) => {
          this.timezoneOptions = res;
        });
    },

    async queryVoiceOptions() {
      const url = `${apiV2Host}/text-to-speech/voices?gender=${this.voiceGender}`;

      try {
        this.fetchingVoice = true;
        this.voiceOptions = [];

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.accessToken
          }
        });

        this.fetchingVoice = false;

        if (!response.ok) {
          this.$notify({
            title: "Fetching Voices Failed!",
            message: `Couldn't fetch voice options.`,
            type: "error"
          });
          return;
        }

        const { voices } = await response.json();

        if (!voices || !voices.length) {
          this.$notify({
            title: "Not Found!",
            message: "No Voices were found!",
            type: "warning"
          });
          return;
        }

        // Map catalog voices to the shape the rest of the form expects (the
        // agents endpoint returns agent.voice in this same shape).
        this.voiceOptions = voices.map((voice) => ({
          id: voice.id,
          name: voice.label,
          description: voice.persona,
          gender: voice.gender
        }));
      } catch (e) {
        this.fetchingVoice = false;
        console.error(e);
      }
    },

    playBgNoise() {
      if (this.enableBackgroundNoise) {
        this.bgAudioEl.currentTime = 0;
        this.bgAudioEl.play();
      }
    },

    pauseBgNoise() {
      this.bgAudioEl.pause();
      this.bgAudioEl.currentTime = 0;
    },

    async playFile() {
      if (this.voiceAudioBlob && !this.isNewVoice) {
        this.audioIsPlaying = true;
        this.audioEl.currentTime = 0;
        this.audioEl.play();
        this.playBgNoise();
        return;
      }

      this.processingTTS = true;

      const { voiceId, agentGreeting } = this.ivaConfigForm;

      const selectedVoice = this.voiceOptions.find((v) => v.id === voiceId);

      if (!selectedVoice) {
        this.processingTTS = false;
        this.$notify({
          title: "Voice Error",
          message: "Selected voice not found",
          type: "error"
        });
        return;
      }

      const requestBody = {
        text: agentGreeting
      };

      this.voiceAudioBlob = null;
      this.isNewVoice = false;

      const url = `${apiV2Host}/text-to-speech/voices/${this.voiceId}/tts`;
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
            Accept: "application/json"
          },
          body: JSON.stringify(requestBody)
        });

        this.processingTTS = false;

        if (!res.ok) {
          const data = await res.json();
          const { message, name, validationErrors } = data;
          this.$notify({
            title: name,
            message: validationErrors ? validationErrors[0] : message,
            type: "error"
          });
          return;
        }

        this.voiceAudioBlob = await res.blob();

        // Create URL for the blob
        const audioUrl = URL.createObjectURL(this.voiceAudioBlob);

        this.audioEl.src = audioUrl;
        this.audioIsPlaying = true;
        this.audioEl.play();
        this.playBgNoise();
      } catch (e) {
        this.processingTTS = false;
        console.error("could not retrieve voice preview", e);
      }
    },

    pauseFile() {
      this.audioIsPlaying = false;
      this.audioEl.pause();
      this.audioEl.currentTime = 0;

      this.pauseBgNoise();
    },

    populateAddressFields(obj) {
      this.addressForm.streetNum = obj["street_number"];
      this.addressForm.streetInfo = obj["route"];
      this.addressForm.city = obj["locality"];
      this.addressForm.state = obj["administrative_area_level_1"];
      this.addressForm.postalCode = obj["postal_code"];
      this.addressForm.locationType = "";
      this.addressForm.locationNumber = "";

      this.address =
        obj["street_number"] +
        " " +
        obj["route"] +
        " " +
        obj["locality"] +
        ", " +
        obj["administrative_area_level_1"] +
        " " +
        obj["postal_code"];
    },

    changeDraggableKey() {
      const randomString = () => Math.random().toString(36).slice(2);
      this.draggableKey = `${randomString()}-${randomString()}$${randomString()}`;
    },

    removeAnnouncementKey(idx) {
      this.announcementKeys.splice(idx, 1);
    },

    async remoteSearchAnnouncements(query, idx) {
      if (query && query.length) {
        try {
          const res = await fetch(
            `${apiV2Host}/admin/announcements?tenantId=${this.selectedTenant.id}&name=${query}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
                "Content-Type": "application/json"
              }
            }
          );
          if (res.ok) {
            const result = await res.json();
            this.announcementKeys[idx].options = [...result.records];
          }
        } catch (error) {
          this.$notify({
            title: error.name,
            message: error.message,
            type: "error"
          });
        }
      }
    },

    onAnnouncementSelection(announcementId, i) {
      if (!announcementId) {
        this.announcementKeys[i].value = null;
        return;
      }

      const announcement = this.announcementKeys[i].options.find(
        (an) => an.id === announcementId
      );

      this.announcementKeys[i].value = {
        id: announcementId,
        name: announcement.name,
        number: announcement.number
      };
    },

    addAnnouncementKey() {
      // Add new field and pre-populate with announcement options
      this.announcementKeys.push({
        options: [...this.announcementOptions],
        id: null,
        value: null
      });
    },

    onRecordingConsentChange(val) {
      if (val === 1) {
        this.openComplianceModal();
      } else {
        this.ivaConfigForm.recordingConsent = 0;
        this.ivaConfigForm.recordingMeId = null;
        this.complianceCurrentUrl = null;
        this.complianceCurrentPlaying = false;
      }
    },

    openComplianceModal() {
      this.complianceVoiceId = null;
      this.complianceVoiceOptions = [];
      this.complianceVoiceGender = null;
      this.revokeCompliancePreview();
      this.complianceModalVisible = true;
      this.prefillComplianceVoice();
    },

    // Prefer the voice the saved consent recording was generated with, and
    // fall back to the location's configured default voice
    // (pil.default_voice_id). Auto-selected, but still editable.
    async prefillComplianceVoice() {
      const token = ++this.compliancePrefillToken;
      const isStale = () =>
        token !== this.compliancePrefillToken || !this.complianceModalVisible;
      this.complianceVoiceFetching = true;
      try {
        const preset =
          (await this.resolveSavedComplianceVoice()) ||
          this.defaultComplianceVoice();
        if (isStale() || !preset) return;
        this.complianceVoiceGender = preset.gender;
        await this.queryComplianceVoiceOptions();
        if (isStale()) return;
        // queryComplianceVoiceOptions resets complianceVoiceId; re-apply the
        // preset only if it exists in the fetched catalog list.
        const match = this.complianceVoiceOptions.find(
          (v) => String(v.id) === String(preset.id)
        );
        if (match) {
          this.complianceVoiceId = match.id;
        }
      } finally {
        if (token === this.compliancePrefillToken) {
          this.complianceVoiceFetching = false;
        }
      }
    },

    defaultComplianceVoice() {
      if (
        !this.agent ||
        !this.agent.defaultVoiceGender ||
        this.agent.defaultVoiceId == null
      ) {
        return null;
      }
      return { gender: this.agent.defaultVoiceGender, id: this.agent.defaultVoiceId };
    },

    // Looks up the catalog voice stored on the saved consent media file.
    // Returns null when there is no recording or its voice can't be resolved.
    async resolveSavedComplianceVoice() {
      const meId = this.ivaConfigForm.recordingMeId;
      if (!meId) return null;
      const headers = { Authorization: `Bearer ${this.$store.state.auth.accessToken}` };
      try {
        const fileRes = await fetch(`${apiV2Host}/admin/media-files/${meId}`, {
          method: "GET",
          headers
        });
        if (!fileRes.ok) return null;
        const file = await fileRes.json();
        if (file && file.mediaUrl && !this.complianceCurrentUrl) {
          this.complianceCurrentUrl = file.mediaUrl;
        }
        if (!file || !file.voiceId) return null;
        const voicesRes = await fetch(`${apiV2Host}/text-to-speech/voices`, {
          method: "GET",
          headers
        });
        if (!voicesRes.ok) return null;
        const { voices } = await voicesRes.json();
        const match = (voices || []).find(
          (v) => String(v.id) === String(file.voiceId)
        );
        return match ? { gender: match.gender, id: match.id } : null;
      } catch (e) {
        console.error(e);
        return null;
      }
    },

    onComplianceGenderChange() {
      // A manual gender change supersedes any in-flight prefill.
      this.compliancePrefillToken++;
      this.queryComplianceVoiceOptions();
    },

    onComplianceVoiceChange() {
      this.revokeCompliancePreview();
    },

    revokeCompliancePreview() {
      if (this.compliancePreviewUrl) {
        URL.revokeObjectURL(this.compliancePreviewUrl);
        this.compliancePreviewUrl = null;
      }
    },

    async previewComplianceVoice() {
      if (!this.complianceVoiceId) return;
      this.compliancePreviewLoading = true;
      try {
        this.revokeCompliancePreview();
        const res = await fetch(
          `${apiV2Host}/text-to-speech/voices/${this.complianceVoiceId}/tts`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
              Accept: "application/json"
            },
            body: JSON.stringify({
              text: "This call is being recorded for compliance and quality purposes. By staying on the line, you consent to the recording."
            })
          }
        );
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          this.$notify({
            title: data.name || "Preview Failed",
            message: data.message || "Could not generate preview",
            type: "error"
          });
          return;
        }
        const blob = await res.blob();
        this.compliancePreviewUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error(e);
        this.$notify({ title: "Preview Failed", message: "Could not generate preview", type: "error" });
      } finally {
        this.compliancePreviewLoading = false;
      }
    },

    async ensureComplianceCurrentUrl() {
      if (this.complianceCurrentUrl || !this.ivaConfigForm.recordingMeId) return;
      this.complianceCurrentLoading = true;
      try {
        const res = await fetch(
          `${apiV2Host}/admin/media-files/${this.ivaConfigForm.recordingMeId}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${this.$store.state.auth.accessToken}` }
          }
        );
        if (!res.ok) return;
        const file = await res.json();
        this.complianceCurrentUrl = file && file.mediaUrl ? file.mediaUrl : null;
      } catch (e) {
        console.error(e);
      } finally {
        this.complianceCurrentLoading = false;
      }
    },

    async toggleComplianceCurrentAudio() {
      const el = this.$refs.complianceCurrentAudio;
      if (this.complianceCurrentPlaying && el) {
        el.pause();
        return;
      }
      if (!this.complianceCurrentUrl) {
        await this.ensureComplianceCurrentUrl();
      }
      if (!this.complianceCurrentUrl) return;
      await this.$nextTick();
      try {
        if (this.$refs.complianceCurrentAudio) {
          await this.$refs.complianceCurrentAudio.play();
        }
      } catch (e) {
        console.error(e);
      }
    },

    async queryComplianceVoiceOptions() {
      this.complianceVoiceId = null;
      this.revokeCompliancePreview();
      const url = `${apiV2Host}/text-to-speech/voices?gender=${this.complianceVoiceGender}`;
      try {
        this.complianceVoiceFetching = true;
        this.complianceVoiceOptions = [];
        const response = await fetch(url, {
          method: "GET",
          headers: { Authorization: "Bearer " + this.$store.state.auth.accessToken }
        });
        this.complianceVoiceFetching = false;
        if (!response.ok) return;
        // New provider-agnostic catalog: { voices: [{ id, label, persona, gender }] }.
        // Map to the shape the compliance select expects (value=id, label=name).
        const { voices } = await response.json();
        this.complianceVoiceOptions = (voices || []).map((voice) => ({
          id: voice.id,
          name: voice.label,
          description: voice.persona,
          gender: voice.gender
        }));
      } catch (e) {
        this.complianceVoiceFetching = false;
        console.error(e);
      }
    },

    async saveComplianceVoice() {
      try {
        this.processingConsentAudio = true;
        const res = await fetch(`${apiV2Host}/admin/pharmacy/agents/${this.agent.id}/consent-audio`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.auth.accessToken}`
          },
          body: JSON.stringify({ voice: this.complianceVoiceId })
        });
        if (!res.ok) {
          const data = await res.json();
          this.$notify({ title: data.name || "Error", message: data.message, type: "error" });
          this.processingConsentAudio = false;
          return;
        }
        const { id } = await res.json();
        this.ivaConfigForm.recordingMeId = id;
        this.ivaConfigForm.recordingConsent = 1;
        this.complianceCurrentUrl = null;
        this.complianceCurrentPlaying = false;
        this.revokeCompliancePreview();
        this.processingConsentAudio = false;
        this.complianceModalVisible = false;
        this.$notify({ type: "success", title: "Success", message: "Recording consent voice saved" });
      } catch (e) {
        this.processingConsentAudio = false;
        console.error(e);
      }
    },

    cancelComplianceModal() {
      this.complianceModalVisible = false;
      this.complianceVoiceGender = null;
      this.complianceVoiceId = null;
      this.complianceVoiceOptions = [];
      this.revokeCompliancePreview();
    },

    async getAnnouncementOptions() {
      try {
        const { accessToken } = this.$store.state.auth;
        const { id: tenantId } = this.selectedTenant;

        const res = await fetch(
          `${apiV2Host}/admin/announcements?tenantId=${tenantId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json"
            }
          }
        );

        if (!res.ok) return;

        const { records } = await res.json();
        this.announcementOptions = records;

        // Map options to the announcement keys in the form
        this.announcementKeys = this.announcementKeys.map((announcement) => ({
          id: announcement.id,
          // Populate with unique options
          options: [
            ...new Map(
              [...announcement.options, ...records].map((item) => [
                item.id,
                item
              ])
            ).values()
          ],
          value: {
            id: announcement.id,
            name: announcement.name,
            number: announcement.description
          }
        }));
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message,
          type: "error"
        });
      }
    }
  },

  filters: {
    formatNumber(value) {
      return phoneNumberFormatter(value);
    }
  },

  mounted() {
    this.queryTimezoneOptions();
    this.getCallerIdNumberOptions();

    const locationInfo = {
      street_number: "short_name",
      route: "long_name",
      locality: "long_name",
      administrative_area_level_1: "short_name",
      postal_code: "short_name"
    };

    this.autocomplete = new google.maps.places.Autocomplete(
      document.querySelector("input[name='autoAddress']")
    );

    this.autocomplete.setFields(["address_components", "geometry"]);
    this.autocomplete.setComponentRestrictions({
      country: ["us"]
    });

    this.autocomplete.addListener("place_changed", () => {
      const place = this.autocomplete.getPlace();
      const ac = place.address_components;

      const locationObject = {
        street_number: "",
        route: "",
        locality: "",
        administrative_area_level_1: "",
        postal_code: ""
      };

      for (let i = 0; i < ac.length; i++) {
        let addressType = ac[i].types[0];
        if (locationInfo[addressType]) {
          locationObject[addressType] = ac[i][locationInfo[addressType]];
        }
      }

      this.populateAddressFields(locationObject);
      this.addressFieldsActive = true;
    });

    this.audioEl = document.getElementById("voice-audio");
    this.bgAudioEl = document.getElementById("bg-noise-audio");

    if (this.audioEl) {
      this.audioEl.addEventListener("ended", () => {
        this.audioIsPlaying = false;

        this.pauseBgNoise();
      });
    }

    if (this.bgAudioEl) {
      this.bgAudioEl.addEventListener("ended", () => {
        if (this.audioIsPlaying) {
          this.pauseBgNoise();
          this.bgAudioEl.play();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-steps {
  width: 150px;
  margin: auto;
  margin-bottom: 30px;
}

.el-form {
  max-width: 600px;
  margin: 20px auto 0 auto;

  .el-checkbox {
    margin-left: 0;
  }

  h4 {
    margin: 12px 0 0 3px;
  }
}

.audio-play-button {
  width: 55px;
  height: 55px;

  i {
    font-size: 2em;
  }
}

.inline-form-group.day-hours {
  margin: 10px 0 20px 0;
}

.voice-selection {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 5px 15px 15px 15px;
  margin-bottom: 10px;
}

.voxo-square-icon {
  width: 25px;
  height: 25px;
  border-radius: 4px;

  svg {
    flex: 0 0 15px;
    height: 15px;
    width: 15px;
  }
}

.file-list {
  border-top: 1px solid #dcdfe6;

  &__item {
    padding: 4px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dcdfe6;
  }
}

.option-card {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 12px;

  &__row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .promise-time-config {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
  }
}

.promise-time-config {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  &__label {
    font-size: 13px;
    font-weight: 500;
    i {
      color: #909399;
      cursor: help;
    }
  }
}

.mb-8 {
  margin-bottom: 8px;
}

.compliance-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #dcdfe6;
}

.compliance-toggle-label {
  font-size: 14px;
  color: #606266;
}

.compliance-modal-label {
  display: block;
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.compliance-current-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
}

.compliance-current-status {
  flex: 1;
  font-size: 13px;
  color: #606266;
}

.compliance-change-voice {
  margin-left: auto;
}

.compliance-preview-row {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}

.compliance-preview-audio {
  width: 100%;
}

body.theme-dark {
  .compliance-toggle-row {
    border-bottom-color: #30363d;
  }

  .compliance-toggle-label {
    color: #c9d1d9;
  }

  .compliance-current-row {
    border-color: #30363d;
  }

  .compliance-current-status {
    color: #c9d1d9;
  }

  .compliance-preview-audio {
    color-scheme: dark;
    border-radius: 999px;
  }

  .voice-selection {
    border: 1px solid #30363d;
  }

  .option-card {
    border-color: #30363d;

    .promise-time-config {
      border-color: #30363d;
    }
  }

  .file-list {
    border-top: 1px solid #30363d;

    &__item {
      border-bottom: 1px solid #30363d;
    }
  }
}
</style>
